import React from 'react';
import { RISING_STAR_PAGE_NAME } from 'constants/pageNames';
import getInitialPropsForRisingStarPage from 'helpers/risingStarPage/getInitialPropsForRisingStarPage';
import { risingStarPageContent } from 'views/RisingStarPage/propTypes';
import RisingStarPageView from 'views/RisingStarPage';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const RisingStarDefaultPage = ({ risingStarPageContent }) => {
  const { title, metaDescription, awardGroups, publishedYears } = risingStarPageContent;

  return (
    <RisingStarPageView
      title={RISING_STAR_PAGE_NAME}
      metaTitle={title}
      metaDescription={metaDescription}
      awardGroups={awardGroups}
      publishedYears={publishedYears}
    />
  );
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const { res } = ctx;
      return await getInitialPropsForRisingStarPage(res);
    })
);

RisingStarDefaultPage.propTypes = {
  risingStarPageContent: risingStarPageContent.isRequired,
};

export default RisingStarDefaultPage;
